import { type DataTableColumn } from "@marketplace/ui/data-table";
import { getRouteApi } from "@tanstack/react-router";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SalesListTableActions } from "../components/sales-list-table-actions";
import type { SalesListItem } from "../types";

const route = getRouteApi("/users/sales/");

export const useSalesListTableColumns = () => {
  const { page } = route.useSearch();
  const { t } = useTranslation("users");

  const salesListTableColumns = useMemo<DataTableColumn<SalesListItem>[]>(
    () => [
      {
        accessor: "no",
        title: "No",
        render: (_, index) => (page - 1) * 10 + index + 1
      },
      {
        accessor: "name",
        title: t("salesListPage.salesListTable.columns.salesName"),
        render: (record) => {
          return <div>{`${record.first_name} ${record.last_name}`}</div>;
        }
      },
      {
        accessor: "email",
        title: t("salesListPage.salesListTable.columns.salesEmail")
      },
      {
        accessor: "role",
        title: t("salesListPage.salesListTable.columns.role"),
        render: () => "Sales"
      },
      {
        accessor: "attributes.referral_id",
        title: t("salesListPage.salesListTable.columns.referralId")
      },
      {
        accessor: "actions",
        title: "",
        render: (record) => <SalesListTableActions salesData={record} />
      }
    ],
    [t, page]
  );

  return { columns: salesListTableColumns };
};
